import { createApp, onMounted } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/font/iconfont.css'
import ElementPlus, { ElTable } from 'element-plus'
import 'element-plus/dist/index.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './assets/css/global.scss'
const app = createApp(App)
app.use(store)
app.use(ElementPlus)
app.use(Antd)
app.use(router)

// 导入 Element Plus 图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 导入 Ant Design Vue 图标
import * as AntDesignIconsVue from '@ant-design/icons-vue'
for (const [key, component] of Object.entries(AntDesignIconsVue)) {
  app.component(key, component)
}
app.mount('#app')
const debounce = (fn: any, delay: any) => {
  let timer = null as any

  return function () {
    const args = [] as any

    clearTimeout(timer)

    timer = setTimeout(function () {
      fn.apply(...args)

    }, delay)

  }

}

const _ResizeObserver = window.ResizeObserver
// 保存原生的 ResizeObserver 到 window 对象
app.config.globalProperties.$nativeResizeObserver = _ResizeObserver;
class customResizeObserver extends _ResizeObserver {
  constructor(callback: any) {
    callback = debounce(callback, 100)

    super(callback)

  }
}
app.config.globalProperties.$customResizeObserver = customResizeObserver;

window.ResizeObserver = customResizeObserver

